import { Component, ComponentRef, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { DataTableParamComponent } from '../../../modules/@datatable/components/datatable-param.component';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { OverlayWindowService } from '../../single-window/shared/overlay-window.service';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '../../../services/http.service';
import { NewsCreateComponent } from '../news-create/news-create.component';
import { NotificationService } from '../../../services/notification.service';
import {NewsEditComponent} from '../news-edit/news-edit.component';
import {GoBackButtonService} from '../../../services/go-back-button.service';
import {debounceTime} from 'rxjs/operators';
import {FancyboxService} from '../../../shared/fancybox.service';

@Component({
    selector: 'app-news',
    templateUrl: './news-list.component.html',
    styleUrls: ['./news-list.component.scss'],
    standalone: false
})
export class NewsListComponent extends DataTableParamComponent implements OnInit, OnDestroy {

  public api_action = 'Data_tables.get_news';
  public columns: Array<{ [key: string]: any }>;
  public formGroup: UntypedFormGroup;
  public createSubscription: Subscription;
  public editSubscription: Subscription;
  private _is_archive = false;
  private subscription: Subscription;
  public dict_tags: Array<any> = [];

  @ViewChild('pubHead', {static: true}) private pubHead: TemplateRef<any>;

  @ViewChild('buttonTmpl', {static: true}) private buttonTmpl: TemplateRef<any>;
  @ViewChild('urlTmpl', {static: true}) private urlTmpl: TemplateRef<any>;
  @ViewChild('pubTmpl', {static: true}) private pubTmpl: TemplateRef<any>;
  @ViewChild('descriptionTmpl', {static: true}) private descriptionTmpl: TemplateRef<any>;
  @ViewChild('nameTmpl', {static: true}) private nameTmpl: TemplateRef<any>;
  @ViewChild('fileTmpl', {static: true}) private fileTmpl: TemplateRef<any>;
  @ViewChild('tagsTmpl', {static: true}) private tagsTmpl: TemplateRef<any>;
  @ViewChild('dateTmpl', {static: true}) private dateTmpl: TemplateRef<any>;

  @ViewChild('viewsCountHead', {static: true})
  private viewsCountHead: TemplateRef<any>;

  @ViewChild('viewsCountTmpl', {static: true})
  private viewsCountTmpl: TemplateRef<any>;

  constructor(public http: HttpClient, public route: ActivatedRoute, public router: Router,
              public fb: UntypedFormBuilder, private overlayWindowService: OverlayWindowService, private goBack: GoBackButtonService,
              public notify: NotificationService, private lightbox: FancyboxService, public activatedRoute: ActivatedRoute) {
    super(http, route, router);

    this.formGroup = this.fb.group({
      'public_status': [''],
    });

    this.subscription = this.formGroup.valueChanges.pipe()
      .subscribe((data) => {
        this.router_param['page'] = 1;
        this.current_page = 1;
        this.changeForm(this.formGroup);
      });
  }

  ngOnInit() {
    this.goBack.header = '<h1>Редактор новостей</h1>';
    this.dict_tags = this.activatedRoute.snapshot.data['tags'];
    this.columns = [
      {'caption': '№', 'name': 'news_id', 'sortable': false},
      {'caption': 'Баннер', 'name': 'file', 'sortable': false, 'template': this.fileTmpl},
      {'caption': 'Заголовок', 'name': 'news_title', 'sortable': false, 'template': this.nameTmpl, 'width': '300px'},
      {'caption': 'Краткое описание', 'name': 'news_description', 'sortable': false, 'template': this.descriptionTmpl, 'width': '400px'},
      // {'caption': 'Ссылка', 'name': 'news_url', 'sortable': false, 'template': this.urlTmpl},
      {'caption': 'Дата', 'name': 'news_date', 'sortable': false, 'template': this.dateTmpl, 'width': '350px'},
      {'caption': 'Публикация', 'name': 'public_status', 'sortable': false, 'template': this.pubTmpl},
      {'caption': 'Тэги', 'name': 'tags', 'sortable': false, 'template': this.tagsTmpl},
      {'caption': 'Просмотры', 'name': 'news_views_count', 'sortable': false,
        'template': this.viewsCountTmpl, 'templateHead': this.viewsCountHead, 'width': '20px'},
      {'caption': '', 'template': this.buttonTmpl}
    ];
    super.ngOnInit();
  }

  ngOnDestroy() {
    if (this.createSubscription) {
      this.createSubscription.unsubscribe();
    }
    if (this.editSubscription) {
      this.editSubscription.unsubscribe();
    }
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  createNews() {
    const dataToSend = {
      dictTags: this.dict_tags
    };
    this.overlayWindowService.openComponentInPopup(NewsCreateComponent, dataToSend)
      .then((factory: ComponentRef<NewsCreateComponent>) => {
        this.createSubscription = factory.instance.onCreate.subscribe(_ => this.loadList());
      });
  }

  deleteNews(news_id) {
    NotificationService.swalConfirm('Вы уверены?', 'Выбранная новость будет перемещена в архив')
      .then(() => {
        this.http.post('News.delete',
          {'news_id': +news_id}
        ).subscribe(
          (response) => {
            this.notify.notifySuccess('Новость успешно удалена', '', 2000);
            this.loadList();
          },
          (error) => this.notify.notifyError('Ошибка', error, 5000)
        );
      }).catch(() => false);
  }


  editNews(news_item) {
    const dataToSend = {
      ...news_item,
      dictTags: this.dict_tags
    };
    this.overlayWindowService.openComponentInPopup(NewsEditComponent, dataToSend)
      .then((factory: ComponentRef<NewsEditComponent>) => {
        this.editSubscription = factory.instance.onEdit.subscribe(_ => this.loadList());
      });
  }

  public get is_archive() {
    return this._is_archive;
  }

  public set is_archive(value: any) {
    this._is_archive = !(value === 'false' || value === false);
    this.loadList();
  }

  prepareQuery() {
    const query = super.prepareQuery();
    query['filter']['is_archive'] = this._is_archive;
    query['filter']['fields'] = {
      'public_status': this.formGroup.value.public_status || null,
    };
    return query;
  }

  displayImage(file_url) {
    this.lightbox.open([{'src': file_url, 'thumb': file_url, 'caption': ''}], 0);
  }
}
